export enum EInvitationStatus {
  Pending = 'PENDING',
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED',
}

export enum EInvitationStatusResponse {
  Pending = 'INVITED',
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED',
}
